import Select from "react-select"
import classNames from "classnames"
import styles from "./styles.module.scss"
import { useState } from "react"
import { Control, useController } from "react-hook-form"
import { getStates } from "@cruisen/react-shared"

const options = getStates().map((state) => ({
  value: state.value,
  label: state.name,
}))

export const CountyPickerInput = ({
  control,
  name,
  label,
  parentBackgroundColor,
  lightOutline = false,
  errorMessage,
  disabled,
  className,
}: {
  control: Control
  name: string
  label: string
  parentBackgroundColor: string
  lightOutline?: boolean
  errorMessage?: string
  disabled?: boolean
  className?: string
}) => {
  const {
    field: { onChange, value },
  } = useController({ control, name })

  const [isFocused, setIsFocused] = useState(false)
  const hasValue = value !== ""
  const selectedValue = options.find((option) => option.value === value)

  return (
    <div className={classNames(styles.inputContainer, className)}>
      <Select
        options={options}
        isDisabled={disabled}
        id={name}
        name={name}
        placeholder=""
        classNamePrefix="county-select"
        className={classNames(
          lightOutline ? styles.lightOutline : styles.darkOutline,
          styles.countySelect,
        )}
        styles={{
          input: (base) => ({
            ...base,
            color: "white",
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: "200px",
            borderRadius: "8px",
          }),
        }}
        components={{
          IndicatorSeparator: () => null,
        }}
        onChange={(option) => onChange(option?.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        value={selectedValue}
      />
      <label
        className={classNames(styles.selectLabel, (isFocused || hasValue) && styles.filled)}
        htmlFor={name}
        style={{ backgroundColor: disabled ? "transparent" : parentBackgroundColor }}
      >
        {label}
      </label>
      {errorMessage && (
        <div className={styles.errorContainer}>
          <p>{errorMessage}</p>
        </div>
      )}
    </div>
  )
}
